<template>
  <div class="language-wrapper inline-block">
    <el-dropdown @command="ChangeLanguage">
      <span class="el-dropdown-link">
        {{ SelectedLanguage.language }}
        <span class="trangle"></span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          :key="item.language"
          v-for="item in Object.keys(SupportedLanguages).map(
            key => SupportedLanguages[key]
          )"
          :command="item"
          >{{ item.language }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import config from '../config.js'
export default {
  inject: ['reload'],
  methods: {
    ChangeLanguage: function(item) {
      this.$store.dispatch('locale/saveLocale', item.abb_name)
    }
  },
  watch: {
    '$store.state.locale.currentLocale'() {
      this.reload()
      this.$store.dispatch('locale/getCustomTerms')
    }
  },
  computed: {
    SupportedLanguages() {
      return config.supported_languages
    },
    SelectedLanguage() {
      let selectedLanguage
      for (let key in config.supported_languages) {
        if (
          config.supported_languages[key].abb_name ===
          this.$store.state.locale.currentLocale
        ) {
          selectedLanguage = config.supported_languages[key]
        }
      }
      return selectedLanguage
    }
  }
}
</script>

<style lang="scss" scoped>
.trangle {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  left: auto !important;
  visibility: visible !important;
  width: auto !important;
  height: auto !important;
  background-color: inherit !important;
  color: white;
  margin-bottom: -3px;
}
</style>
